import { Box, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import countryCodes from "@components/CustomContryCode/countrys";
import "@components/CustomContryCode/CustomContryCode.css";

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

/**
 * Selector de código de país para teléfono. Reusa la data y el sprite de
 * banderas de `CustomContryCode` (fuente de verdad de países soportados),
 * pero restyleado como `.select` compacto del diseño de onboarding: sin
 * label flotante, solo bandera + código, ancho fijo ~96px.
 */
export const CountrySelect = ({ value, onChange, disabled }: Props) => (
  <Select
    size="lendia_input"
    value={value}
    disabled={disabled}
    onChange={(e: SelectChangeEvent) => onChange(e.target.value)}
    sx={{
      minWidth: 96,
      flexShrink: 0,
      "& .MuiSelect-select": {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        paddingLeft: "12px",
        paddingRight: "28px !important",
      },
      "& .MuiSelect-disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
      },
    }}
    renderValue={(v) => {
      const country = countryCodes.find((c) => c.code === v);
      return (
        <Box className="custom-country-code" sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {country && <Box component="span" className={`flag ${country.img}`} />}
          <Typography component="span" sx={{ fontVariantNumeric: "tabular-nums", fontSize: 13.5 }}>
            {v}
          </Typography>
        </Box>
      );
    }}
  >
    {countryCodes.map((c, i) => (
      <MenuItem key={`${i}-${c.img}`} value={c.code}>
        <Box className="custom-country-code" sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
          <Box component="span" className={`flag ${c.img}`} />
          <Typography component="span" sx={{ fontSize: 13, color: "primary.dark", flex: 1 }}>
            {c.name}
          </Typography>
          <Typography
            component="span"
            sx={{ fontSize: 12.5, color: "text.secondary", fontVariantNumeric: "tabular-nums" }}
          >
            {c.code}
          </Typography>
        </Box>
      </MenuItem>
    ))}
  </Select>
);
